import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router"

import { Card, Container, Table, Text } from "ui"

import Attribute from "features/records/components/Attribute"

const BlockTable = props => {
    const columns = [
        {
            accessor: "name",
            Header: "Name",
            Cell: cell => (
                <Attribute
                    onChange={value => {
                        props.onChange(cell.original._sid, { name: value })
                    }}
                    editable
                    inline
                >
                    {cell.value}
                </Attribute>
            ),
        },
        {
            accessor: "_sid",
            Header: "",
            Cell: cell => (
                <Fragment>
                    <Link to={"/blocks/" + cell.value}>
                        <Text margin="none">Edit</Text>
                    </Link>
                </Fragment>
            ),
        },
    ]

    let data = props.data
    return (
        <Card>
            <Table columns={columns} data={data} dataLabel="blocks" />
        </Card>
    )
}

BlockTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
}
export default BlockTable



// WEBPACK FOOTER //
// ./src/features/studio/components/BlockTable.js